import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import {
  MapContainer,
  TileLayer,
  ZoomControl,
  LayersControl,
  GeoJSON,
} from "react-leaflet";
// import L from "leaflet";
import "leaflet/dist/leaflet.css";

import regService from "../../services/regsugar.service";

// import lines from "./line.json";
// functions
// import { getAllLayers } from "../functions/map";

const Map = (props) => {
  const [deeds, setDeeds] = useState({});
  var mb_token =
    "pk.eyJ1IjoibWFwaGV3IiwiYSI6ImNqNGE0bHljNzEwNHQzMnA3cmFkMnZpMXkifQ.nRZ79Ob2sd6nLu-cVHPiLA";
  useEffect(() => {
    regService
      .getMapDeed()
      .then((response) => {
        // alert(JSON.stringify(response.data));
        setDeeds(response.data.jsonb_build_object);
      })
      .catch((err) => alert(err));
  }, []);
  // const styleLines = (segments) => {
  //   return {
  //     color: "red",
  //     weight: 4,
  //     opacity: 1,
  //   };
  // };
  const onEachFeature = (feature, layer) => {
    if (feature.properties) {
      const { person_card_id, name } = feature.properties;
      // layer.bindPopup(file_name);
      layer.bindPopup(
        "<h3>แปลงที่ดิน : </h3><p>บัตรประชาชน: " +
          person_card_id.toString() +
          "</p>" +
          "<p>ชื่อ - สกุล: " +
          name +
          "</p>"
      );
      // layer.bindTooltip(person_card_id.toString(), {
      //   permanent: true,
      //   direction: "center",
      //   className: "lineLabel",
      // });
      // events
      layer.on({
        mouseover: function () {
          this.setStyle({
            color: "#b45501",
            weight: 6,
          });
        },
        mouseout: function () {
          this.setStyle({
            color: "red",
          });
        },
        // click: function () {
        //   // TODO Link to page
        //   alert("Clicked on " + file_name);
        // },
      });
    }
  };

  const handleClose = () => {
    props.hidden(false);
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แผนที่</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <MapContainer
            center={[13.88, 100.46]}
            zoom={6}
            zoomControl={false}
            style={{ position: "relative", width: "100%", height: "60vh" }}
          >
            <LayersControl position="topright">
              {/* 
            Give the layer a name that will be displayed inside of the layers control.
            We also want to pass the checked prop to whichever map tile we want
            displayed as the default:
          */}
              <LayersControl.BaseLayer checked name="Basic Map">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              {/* 
            Add the second maptile:
          */}
              <LayersControl.BaseLayer name="Topo Map">
                <TileLayer
                  attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
                  url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="Map box">
                <TileLayer
                  attribution='Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>'
                  url="https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}"
                  id="mapbox.satellite"
                  accessToken={mb_token}
                />
              </LayersControl.BaseLayer>
              <LayersControl.Overlay checked name={"Deed"}>
                {Object.keys(deeds).length === 0 ? (
                  ""
                ) : (
                  <GeoJSON
                    data={deeds}
                    // style={styleLines}
                    onEachFeature={onEachFeature}
                  />
                )}

                {/* {
              // Iterate the borderData with .map():
              lines.features.map((data) => {
                // Get the layer data from geojson:
                const geojson = data.geometry;
                // Get the name of the state from geojson:
                const state_name = data.properties.file_name;
                return (
                  // Pass data to layer via props:
                  <>
                    <GeoJSON
                      key={state_name}
                      data={geojson}
                      pathOptions={{ color: "blue" }}
                    />
                  </>
                );
              })
            } */}
              </LayersControl.Overlay>
            </LayersControl>
            <ZoomControl position="topright" />
          </MapContainer>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default Map;

Map.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
};
